import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aid-under-construction',
  template: `
    <div
      style="padding: 32px"
      class="aid-layout-row aid-layout-align-center-start"
    >
      <div class="mat-headline-6">
        {{ 'under-construction' | translate }}
      </div>
    </div>
  `,
  styleUrls: ['./under-construction.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UnderConstructionComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
